/*
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author: ZhangLei
 * @Date: 2020-08-18 13:56:13
 * @LastEditTime: 2020-08-18 13:56:52
 * @LastEditors: ZhangLei
 * @Description:
 * @FilePath: /desktop/src/store/modules/domain.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
import {
  getConfigData,
  createConfig,
  editConfig,
  getConfigInfo,
  deleteConfig
} from "@/service/configService";
const config = {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    /**
     * 获取config列表
     */
    getConfigData(store, info) {
      return new Promise((resolve, reject) => {
        getConfigData(info)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 创建config
     * @param {*} store
     * @param {*} data
     */
    createConfig(store, data) {
      return new Promise((resolve, reject) => {
        createConfig(data)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 获取config详情
     * @param {*} store
     * @param {*} id
     */
    getConfigInfo(store, id) {
      return new Promise((resolve, reject) => {
        getConfigInfo(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 编辑config
     * @param {*} store
     * @param {*} data
     */
    editConfig(store, data) {
      return new Promise((resolve, reject) => {
        editConfig(data)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 删除config
     * @param {*} store
     * @param {*} id
     */
    deleteConfig(store, id) {
      return new Promise((resolve, reject) => {
        deleteConfig(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};
export default config;



// WEBPACK FOOTER //
// ./src/store/modules/config.js